import React from 'react';
import {
  Assessment as ReportsIcon,
  Receipt as ReceiptIcon,
  Payment as PaymentIcon,
  RequestQuote as InvoiceIcon,
  Description as QuoteIcon,
} from '@mui/icons-material';
import TabHub from '../../components/layout/TabHub';
import FinancialReportPage from '../reports/FinancialReportPage';
import ExpensesPage from '../finance/ExpensesPage';
import ComisionesBalancesTab from './ComisionesBalancesTab';
import InvoiceGeneratorPage from '../invoices/InvoiceGeneratorPage';
import QuoteGeneratorPage from '../quotes/QuoteGeneratorPage';

// Hub de Finanzas: unifica todo lo relacionado con dinero en una sola pantalla.
const FinanzasHub: React.FC = () => (
  <TabHub
    tabs={[
      { key: 'resumen', label: 'Resumen', icon: <ReportsIcon />, element: <FinancialReportPage /> },
      { key: 'gastos', label: 'Gastos', icon: <ReceiptIcon />, element: <ExpensesPage /> },
      { key: 'comisiones', label: 'Comisiones / Balances', icon: <PaymentIcon />, element: <ComisionesBalancesTab /> },
      { key: 'facturas', label: 'Facturas', icon: <InvoiceIcon />, element: <InvoiceGeneratorPage /> },
      { key: 'cotizaciones', label: 'Cotizaciones', icon: <QuoteIcon />, element: <QuoteGeneratorPage /> },
    ]}
  />
);

export default FinanzasHub;
